// extracted by mini-css-extract-plugin
export default {"StreakSummary":"StreakSummary_StreakSummary__2NQte","Item":"StreakSummary_Item__ONJyb","DayLabel":"StreakSummary_DayLabel__mK2tk"};